import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
export const WalletAddress = ({ address, format = 'short', noAddressText = 'N/A', className }) => {
    const formattedAddress = useMemo(() => {
        if (!address)
            return noAddressText;
        if (format === 'short') {
            return `${address.slice(0, 6)}...${address.slice(-4)}`;
        }
        return address;
    }, [address, format, noAddressText]);
    return _jsx("span", { className: className, children: formattedAddress });
};
//# sourceMappingURL=wallet-address.js.map